export const contactsData = {
    email: 'wmccoy104609@gmail.com',
    phone: '+12019522193',
    address: 'New Jersey, United States',

    sheetAPI: ''
}